import { loadVideoPlayer } from './utils/videoPlayer';
import { loadYouTubeVideo } from './utils/youtube';
import {
  handleYouTubePlayButton,
  handleURLVideoPlayButton,
  handleURLVideoMuteButton,
  handleURLVideoPlayPauseButton
} from './utils/controls';
import { addVideoEventListeners } from './utils/videoPlayer';
import { updatePosterImage } from './utils/posterImage';

document.addEventListener('DOMContentLoaded', () => {
  //debugger;
  const videoWrappers = document.querySelectorAll('.pr-video');

  videoWrappers.forEach(videoWrapper => {
    const posterImageContainer = videoWrapper.querySelector('.pr-video__poster-image-container');
    const videoType = videoWrapper.getAttribute('data-video-type');
    const autoplay = videoWrapper.getAttribute('data-autoplay') === 'true';
    const muted = videoWrapper.getAttribute('data-muted') === 'true';
    const loop = videoWrapper.getAttribute('data-loop') === 'true';
    const controls = videoWrapper.getAttribute('data-controls') === 'true';

    if (videoType === 'youtube') {
      const youtubeVideoUrl = videoWrapper.getAttribute('data-youtube-video');

      if (posterImageContainer) {
        handleYouTubePlayButton(videoWrapper, youtubeVideoUrl, { autoplay, muted, loop, controls });
      } else {
        loadYouTubeVideo(videoWrapper, youtubeVideoUrl, { autoplay, muted, loop, controls });
      }

    } else if (videoType === 'wp-upload' || videoType === 'insert-url') {
      const desktopVideoUrl = videoWrapper.getAttribute('data-desktop-video');
      const tabletVideoUrl = videoWrapper.getAttribute('data-tablet-video');
      const mobileVideoUrl = videoWrapper.getAttribute('data-mobile-video');

      if (desktopVideoUrl) {
        loadVideoPlayer(videoWrapper, desktopVideoUrl, tabletVideoUrl || desktopVideoUrl, mobileVideoUrl || desktopVideoUrl);
        if (posterImageContainer) {
          handleURLVideoPlayButton(videoWrapper);
          handleURLVideoMuteButton(videoWrapper);
          handleURLVideoPlayPauseButton(videoWrapper);
        } else {
          const $videoElement = videoWrapper.querySelector('video');
          if ($videoElement) {
            addVideoEventListeners($videoElement, videoWrapper);
            handleURLVideoMuteButton(videoWrapper);
            handleURLVideoPlayPauseButton(videoWrapper);
          }
        }
      } else {
        console.warn('No desktop video URL found for video wrapper:', videoWrapper);
      }
    } else {
      console.warn('Unknown video type:', videoType);
    }

    // Update the poster image based on the screen size
    updatePosterImage(videoWrapper);

    // Add event listener for window resize to update the poster image
    window.addEventListener('resize', () => updatePosterImage(videoWrapper));
  });
});
